import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack, Typography} from 'views/components';

import {HoverToolBox, Translate, translate, MarkdownViewer} from 'views/module';

import Contacts from './contacts/Contacts';

const RelationshipView = (props) => {
  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const relationshipData = props.relationshipData;
  const removeRelationship = props.removeRelationship;
  const editRelationship = props.editRelationship;
  const clientBackend = props.clientBackend;
  const userIdentity = props.userIdentity;
  const userNotificationChannels = props.userNotificationChannels;
  const userCommunication = props.userCommunication;
  const userDialpadIntegration = props.userDialpadIntegration;
  const clientAuthenticationLoading = props.clientAuthenticationLoading;
  const clientNotificationLoading = props.clientNotificationLoading;
  const clientCommunicationLoading = props.clientCommunicationLoading;
  const clientDialpadIntegrationLoading = props.clientDialpadIntegrationLoading;

  React.useEffect(() => {
    const clientRelationshipRn = relationshipData.relationshipRn;
    clientBackend.user.getUser(clientRelationshipRn);
  }, [relationshipData.relationshipRn]);

  React.useEffect(() => {
    const clientRelationshipRn = relationshipData.relationshipRn;
    clientBackend.notification.getChannels(clientRelationshipRn);
  }, [relationshipData.relationshipRn]);

  React.useEffect(() => {
    const clientRelationshipRn = relationshipData.relationshipRn;
    clientBackend.communication.getSmsSubscription(clientRelationshipRn);
  }, [relationshipData.relationshipRn]);

  React.useEffect(() => {
    const clientRelationshipRn = relationshipData.relationshipRn;
    const clientRn = clientRelationshipRn.split(':RELATIONSHIP')[0];
    clientBackend.dialpadIntegration.getDialpadLink(clientRn, clientRelationshipRn);
  }, [relationshipData.relationshipRn]);

  React.useEffect(() => {
    setToolbarVisible(mouseOver);
  }, [mouseOver]);

  return (
    <Box>
      <Divider />
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted' : 'inherit',
          px: 2,
          pt: 2,
          pb: 5,
        }}
      >
        <Stack
          spacing={1}
        >
          {/* Display Relationship Name */}
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Name' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center'}}
            >
              {relationshipData.name}
            </Typography>
          </Box>
          <Box>
            {/* Display Connection Type */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.ConnectionType' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.connectionType}
            </Typography>
          </Box>
          <Box>
            {/* Display Priority */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Priority' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.priority}
            </Typography>
          </Box>
          <Box>
            {/* Display Description */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Description' />
            </Typography>
            <MarkdownViewer
              value={relationshipData.description.blob || translate('client.ClientDetail.Relationships.Details.NoDescription')}
              truncate
              truncateLine={8}
            />
          </Box>
          <Contacts
            relationshipData={relationshipData}
            clientBackend={clientBackend}
            userIdentity={userIdentity}
            userNotificationChannels={userNotificationChannels}
            userCommunication={userCommunication}
            userDialpadIntegration={userDialpadIntegration}
            clientAuthenticationLoading={clientAuthenticationLoading}
            clientNotificationLoading={clientNotificationLoading}
            clientCommunicationLoading={clientCommunicationLoading}
            clientDialpadIntegrationLoading={clientDialpadIntegrationLoading}
          />
        </Stack>

        {/* Hover ToolBox */}
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          onClickDelete={() => removeRelationship(relationshipData.relationshipRn)}
          onClickEdit={() => editRelationship(relationshipData, userIdentity)}
          hideTool={{
            emoji: true,
            copy: true,
            edit: false,
            delete: false,
          }}
        />
      </Box>
    </Box>
  );
};

RelationshipView.propTypes = {
  relationshipData: PropTypes.object.isRequired,
  removeRelationship: PropTypes.func.isRequired,
  editRelationship: PropTypes.func.isRequired,
  clientBackend: PropTypes.object.isRequired,
  userIdentity: PropTypes.object,
  userNotificationChannels: PropTypes.shape({
    emails: PropTypes.array,
    smsNumbers: PropTypes.array,
  }),
  userCommunication: PropTypes.object,
  userDialpadIntegration: PropTypes.object,
  clientAuthenticationLoading: PropTypes.bool.isRequired,
  clientNotificationLoading: PropTypes.bool.isRequired,
  clientCommunicationLoading: PropTypes.bool.isRequired,
  clientDialpadIntegrationLoading: PropTypes.bool.isRequired,
};

export default React.memo(RelationshipView);
